import { cva, type VariantProps } from "class-variance-authority";
import { LoaderCircleIcon } from "lucide-react";
import { cn } from "../utils";

const spinner = cva("animate-spin", {
  variants: {
    $size: {
      sm: "h-4 w-4",
      md: "h-8 w-8",
      lg: "h-12 w-12",
    },
    $tone: {
      primary: "text-primary",
      muted: "text-text-light",
      inverse: "text-white",
    },
  },
  defaultVariants: {
    $size: "md",
    $tone: "primary",
  },
});

type SpinnerProps = Omit<React.ComponentProps<"div">, "children"> &
  VariantProps<typeof spinner> & {
    /** Accessible label announced to screen readers. */
    label?: string;
  };

export function Spinner({ $size, $tone, className, label = "Loading", ...props }: SpinnerProps) {
  return (
    <div role="status" aria-label={label} {...props}>
      <LoaderCircleIcon aria-hidden="true" className={cn(spinner({ $size, $tone }), className)} />
    </div>
  );
}
